window.rideStylerEnvironment = "beta";
